import { useEffect, useState } from 'react';
import { IoCloudDownload } from 'react-icons/io5';
import { Redirect, useParams } from 'react-router-dom';
import {
  downloadAditionalDocument,
  downloadFollowupRaport,
  downloadRaport
} from '../../network/raports';
import { ROUTES } from '../../routing/routes';
import CButton from '../button/button';
import styles from './ccr-report.module.scss';
import { typesDocuments } from '../../types/documents';
import { types } from 'util';

interface CcrRerportParams {
  id: any;
}

interface ICcrReport {
  type?: any;
}

const CcrReport = (props: ICcrReport) => {
  let { id } = useParams<CcrRerportParams>();

  const downloadDocument = () => {};

  return (
    <div className={styles.downloadCcrContainer}>
      <div className={styles.card}>
        <div className={styles.details}>
          <p className='body-dark faded'>Descarcare document</p>
          <div className={styles.list}>
            <CButton
              label={
                <p className={styles.download}>
                  Descarcă Documentul <IoCloudDownload />
                </p>
              }
              onClick={() => {
                if (props.type == typesDocuments.ADDITIONAL_DOCUMENT) {
                  downloadAditionalDocument(id, 'Aditional Document');
                }

                if (props.type == typesDocuments.FOLLOWUP_CCR_RAPORT) {
                  downloadFollowupRaport(id, 'Follow-up');
                }
                if (props.type == typesDocuments.CCR_RAPORT) {
                  downloadRaport(id, 'Raport');
                }
              }}
              type='button'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CcrReport;
